import { Skeleton, styled, TableCell, TableRow } from "@mui/material";
import React from "react";
import { ITableSkeletonProps } from "./interfaces/ITableSkeletonProps";

const TableRowCell = styled(TableCell)(({ theme }) => ({
  padding: "4px 4px",
}));

export const TableSkeleton: React.FC<ITableSkeletonProps> = (props) => {
  const { numberOfCells, numberOfRows = 5 } = props;
  const rows = Array.from(Array(numberOfRows), (_, i) => `row-${i + 1}`);
  const cellsarr = Array.from(Array(numberOfCells), (_, i) => i + 1);

  return (
    <>
      {rows.map((row, index) => {
        return (
          <TableRow key={row}>
            {cellsarr.map((cell) => {
              return (
                <TableRowCell key={cell}>
                  <Skeleton />
                </TableRowCell>
              );
            })}
          </TableRow>
        );
      })}
    </>
  );
};
